import React from 'react';
import { Portfolio } from '../components/Portfolio';
export function WorkPage() {
  return <main className="pt-24" data-id="element-240">
      <Portfolio data-id="element-241" />
    </main>;
}